import {useTranslation} from 'react-i18next';
import {cn} from '@chekin/guestapp-ui-kit';

type Props = {
  onClick: () => void;
  className?: string;
};

export function AutoFillBox({onClick, className}: Props) {
  const {t} = useTranslation();

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'auto-fill-card flex w-full max-w-[458px] cursor-pointer flex-col gap-6 rounded-[24px] bg-white p-4 text-left shadow-[inset_0_0_0_1px_#DDDDDD]',
        className,
      )}
    >
      <div className="flex w-full flex-row items-center gap-4">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.1893 1.5C13.543 1.5 13.8837 1.62487 14.1526 1.85018L14.25 1.93934L16.0613 3.75H18.75C20.7106 3.75 22.3197 5.25453 22.4859 7.17199L22.4965 7.33733L22.5 7.5V18C22.5 20.0166 20.9083 21.6614 18.9127 21.7465L18.75 21.75H5.25C3.23343 21.75 1.58864 20.1583 1.50346 18.1627L1.5 18V7.5C1.5 5.48343 3.09173 3.83864 5.08733 3.75346L5.25 3.75H7.9605L9.74667 1.94506C9.96582 1.72355 10.2468 1.57738 10.5494 1.52335L10.6802 1.50589L10.813 1.5H13.1893ZM13.1893 3H10.813L8.58712 5.25H5.25C4.05174 5.25 3.07225 6.18669 3.00382 7.3678L3 7.5V18C3 19.1983 3.93669 20.1777 5.1178 20.2462L5.25 20.25H18.75C19.9483 20.25 20.9277 19.3133 20.9962 18.1322L21 18V7.5C21 6.30174 20.0633 5.32225 18.8822 5.25382L18.75 5.25H15.4393L13.1893 3ZM12 6.75C15.3137 6.75 18 9.43629 18 12.75C18 16.0637 15.3137 18.75 12 18.75C8.68629 18.75 6 16.0637 6 12.75C6 9.43629 8.68629 6.75 12 6.75ZM12 8.25C9.51472 8.25 7.5 10.2647 7.5 12.75C7.5 15.2353 9.51472 17.25 12 17.25C14.4853 17.25 16.5 15.2353 16.5 12.75C16.5 10.2647 14.4853 8.25 12 8.25ZM5.25 6.75C5.66421 6.75 6 7.08579 6 7.5C6 7.91421 5.66421 8.25 5.25 8.25C4.83579 8.25 4.5 7.91421 4.5 7.5C4.5 7.08579 4.83579 6.75 5.25 6.75Z"
              fill="var(--primary)"
            />
          </svg>
        </div>
        <div className="flex flex-1 flex-col gap-1">
          <span className="auto-fill-card__title text-[16px] font-medium leading-5">
            {t('auto_fill_your_details')}
          </span>
          <span className="auto-fill-card__subtitle text-[14px] font-normal leading-[18px] text-[#6C6C6C]">
            {t('auto_fill_scanning_description')}
          </span>
        </div>
      </div>
    </button>
  );
}
